// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__39f7s","col":"styles_col__30G4-"};